import { ETipoImovel } from '@/services/constants'
import { Generico } from './IGenerico'
import { DateTime } from 'luxon'
import { IMultibancosCliente } from './IMultibancosCliente'

/**
 * Interfaces e modelos relacionados ao módulo de Crédito Imobiliário
 */
export namespace CreditoImobiliario {
	export interface IScoreItemResponse {
		idSolicitacao: number
		status: number
		id: number
		score: string
		subScore: string
		ltv: number
		taxa: number
		fornecedorId: number
		fornecedor: string
		tipoImovel: number
		propostaExiste: boolean
		permitirGerarProposta: boolean
		valorPreAprovado: null | number
		produto: null | number
	}

	export interface IPreAnaliseModel {
		dadosOperacao: IDadosOperacao
		dadosImovel: IDadosImovel
		dadosVendedor: Array<IDadosVendedor>
		proponentes: Array<IMultibancosCliente>
		propostaInfosList: Array<IMultibancosInfosProposta>
	}

	export class PreAnaliseModel implements IPreAnaliseModel {
		dadosOperacao: IDadosOperacao
		dadosImovel: IDadosImovel
		dadosVendedor: Array<IDadosVendedor>
		proponentes: IMultibancosCliente[]
		propostaInfosList: Array<IMultibancosInfosProposta>

		constructor(dadosOperacao: IDadosOperacao, proponentes: Array<IMultibancosCliente>, dadosImovel: IDadosImovel) {
			this.dadosOperacao = dadosOperacao
			this.proponentes = proponentes //new Array<IMultibancosCliente>()
			this.dadosImovel = dadosImovel
			this.dadosVendedor = new Array<IDadosVendedor>()
			this.propostaInfosList = new Array<IMultibancosInfosProposta>()
		}
	}

	export interface IDadosOperacao {
		bancos: Array<number>
		idUsuario: number
		idParceiro: number
		idFranquia: number
		valorImovel: number
		valorEntrada: number
		valorFinanciado: number
		valorFGTS: number
		utilizarFGTS: Boolean
		valorDespesas: number
		financiarDespesas: Boolean
		incluirTarifas: Boolean
		diaPrestacao: number
		estado: number
		situacao: number
		prazo: number
		tipoImovel: ETipoImovel
		bradescoTipoParcela: number
		itauProdutoSacPlus: number
		bradescoProduto: number
		corretorId: string | null
		parceiroNome: string
		hubNome: string
		corretorNome: string
		nmBanco: string
		nrAgencia: string
		mortgageIntentionUuid: string | null
	}

	export class DadosOperacao implements IDadosOperacao {
		parceiroNome: string = ''
		hubNome: string = ''
		corretorNome: string = ''
		corretorId: string | null = null
		idUsuario: number = -1
		bancos: number[] = new Array<number>()
		idParceiro: number = -1
		idFranquia: number = -1
		valorImovel: number = 0
		valorEntrada: number = 0
		valorFinanciado: number = 0
		valorFGTS: number = 0
		utilizarFGTS: Boolean = false
		valorDespesas: number = 0
		financiarDespesas: Boolean = false
		incluirTarifas: Boolean = false
		diaPrestacao: number = 0
		estado: number = 0
		situacao: number = 0
		prazo: number = 0
		tipoImovel: ETipoImovel = ETipoImovel.RESIDENCIAL
		bradescoTipoParcela: number = 1
		itauProdutoSacPlus: number = 1
		bradescoProduto = 1
		nmBanco: string = ''
		nrAgencia: string = ''
		mortgageIntentionUuid: string | null = null
	}

	export interface IDadosImovel {
		cep: string
		endereco: string | null
		numero: string | null
		complemento: string
		bairro: string | null
		cidade: string | null
		uf: string | null
		quantidadeVagasGaragem: number
		numeroIdentificacaoVaga: string
		condominio: boolean
		nomeContato: string
		numeroCelular: string
		numeroTelefone: string
		diasPrestacao: number
		intervenienteQuitante: boolean
		iqVlrDivida?: number
	}

	export class DadosImovel implements IDadosImovel {
		cep: string = ''
		endereco: string | null = ''
		numero: null = null
		complemento: string = ''
		bairro: string | null = ''
		cidade: string | null = ''
		uf: string | null = ''
		quantidadeVagasGaragem: number = 0
		numeroIdentificacaoVaga: string = ''
		condominio: boolean = false
		nomeContato: string = ''
		numeroCelular: string = ''
		numeroTelefone: string = ''
		diasPrestacao: number = 0
		intervenienteQuitante: boolean = false
	}

	export interface IDadosVendedor {
		tipoVendedor: string
		email: string
		cpfCnpj: string
		nome: string
		estadoCivil: number | null
		telefone: string
		cep: string
		endereco: string | null
		numero: number | null
		complemento: string
		bairro: string | null
		cidade: string | null
		uf: string
		correntistaBradesco: number
		profissao: string
		conjugeExiste: boolean
		conjugeNome: string
		conjugeCpf: string
		conjugeEmail: string
		agenciaNumero: string
		agenciaDigito: string
		contaNumero: string
		contaDigito: string
	}

	export class DadosVendedor implements IDadosVendedor {
		tipoVendedor: string = ''
		email: string = ''
		cpfCnpj: string = ''
		nome: string = ''
		estadoCivil: number | null = null
		telefone: string = ''
		cep: string = ''
		endereco: string | null = ''
		numero: number | null = null
		complemento: string = ''
		bairro: string | null = ''
		cidade: string | null = ''
		uf: string = ''
		correntistaBradesco: number = 0
		profissao: string = ''
		conjugeExiste: boolean = false
		conjugeNome: string = ''
		conjugeEmail: string = ''
		conjugeCpf: string = ''
		agenciaNumero: string = ''
		agenciaDigito: string = ''
		contaNumero: string = ''
		contaDigito: string = ''
	}

	export interface IPreAnaliseData {
		cpfTitular: number
		dataCadastro: string
		franquiaDDD: string
		franquiaEndereco: string
		franquiaNome: string
		franquiaTelefone: string
		nomeTitular: string
		nomeUsuario: string
		parceiroNome: string
		telefone: string
		email: string
		offerId: string
		dataNascimento: DateTime
		situacao: number
		priority: number
		displayOrder: number
		attributedConsultantName: string
		userId5A: number
	}

	export class PreAnaliseData implements IPreAnaliseData {
		cpfTitular!: number
		dataCadastro!: string
		franquiaDDD!: string
		franquiaEndereco!: string
		franquiaNome!: string
		franquiaTelefone!: string
		nomeTitular!: string
		nomeUsuario!: string
		parceiroNome!: string
		telefone!: string
		email!: string
		offerId!: string
		dataNascimento!: DateTime
		situacao!: number
		priority!: number
		displayOrder!: number
		attributedConsultantName!: string
		userId5A!: number
	}

	export interface IMultibancosInfosProposta {
		propostaItauId: number
		fornecedorId: number
		mensagemErro: string
		permitirReenvio: boolean
		statusId: number
		statusNome: string
		statusIsolve: number
	}

	export interface IGerarPropostaProduto {
		fornecedorId: number
		tipoProdutoId: number
	}

	export class GerarPropostaProduto implements IGerarPropostaProduto {
		fornecedorId!: number
		tipoProdutoId!: number
	}

	export interface IGerarPropostaSubProduto {
		fornecedorId: number
		tipoProdutoId: number
		tipoSubProdutoId: number
	}

	export class GerarPropostaSubProduto implements IGerarPropostaSubProduto {
		fornecedorId!: number
		tipoProdutoId!: number
		tipoSubProdutoId!: number
	}

	export interface IScoreResponse extends Generico.IApiResponse<Array<IScoreItemResponse>> {}
}
